import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PaymentsTableTab from '@/components/payments/PaymentsTableTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import {
    NON_CLEARED_STATUSES,
    PENDING_ONLY_STATUSES,
} from '@/services/paymentStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpcomingPaymentsTab',
  props: {
    tabId: {}
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PaymentsTableTab, {
    "base-statuses": _unref(NON_CLEARED_STATUSES),
    "default-statuses": _unref(PENDING_ONLY_STATUSES),
    "status-options": _unref(NON_CLEARED_STATUSES),
    "empty-description": "No pending payments match your current filters.",
    "process-date-mode": "process-date",
    "action-mode": "none"
  }, null, 8, ["base-statuses", "default-statuses", "status-options"]))
}
}

})